import { ApolloProvider } from '@apollo/client';
import 'balloon-css';
import { ConnectedRouter } from 'connected-react-router';
import './tailwind.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from '@/app/app';
import { history } from '@/app/app-reducer';
import { store } from '@/app/app-store';
import { RootErrorBoundary } from '@/error-boundaries/root-error-boundary';
import { client } from '@/utils/gqlapi';

const AppWithErrorBoundary = RootErrorBoundary.withBoundary()(App);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ApolloProvider client={client}>
        <AppWithErrorBoundary />
      </ApolloProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
